/*
 * @Description: 专区历史数据浏览效果评价
 * @Date: 2024-01-15 14:09:19
 */
import BiTmplDetail_18 from './bi-tmpl-detail-18.vue';
export default BiTmplDetail_18;
